import {sendAgentEvent} from './eventClient';

let activeModal = null;

/**
 * Track the modal opened for an agent command.
 * @param {object} envelope command correlation
 * @param {Function|null} close modal close callback
 * @return {void}
 */
export function trackActiveAgentModal(envelope, close) {
	activeModal = {
		request_id: envelope.request_id,
		command_id: envelope.command_id,
		session_id: envelope.session_id,
		workflow_instance_id: envelope.workflow_instance_id,
		workflow_revision: envelope.workflow_revision,
		idempotency_key: envelope.idempotency_key,
		close: typeof close === 'function' ? close : null,
	};
}

/**
 * Dismiss the modal owned by the active agent workflow.
 * @return {void}
 */
export function dismissActiveAgentModal() {
	const modal = activeModal;
	activeModal = null;
	modal?.close?.();
}

/**
 * Report a user-driven modal lifecycle outcome.
 * @param {'modal.cancelled'|'modal.saved'|'modal.failed'} eventType lifecycle event
 * @param {string|null} errorCode Canvas error identifier
 * @return {Promise<object|null>} agent response
 */
export async function reportActiveAgentModalLifecycle(eventType, errorCode = null) {
	if (!['modal.cancelled', 'modal.saved', 'modal.failed'].includes(eventType)) {
		return null;
	}
	const envelope = activeModal;
	if (!envelope) return null;
	activeModal = null;
	const response = await sendAgentEvent({
		request_id: envelope.request_id,
		command_id: envelope.command_id,
		session_id: envelope.session_id,
		event_type: eventType,
		result: {},
		error_code: errorCode,
		workflow_instance_id: envelope.workflow_instance_id,
		workflow_revision: envelope.workflow_revision,
		idempotency_key: envelope.idempotency_key,
	});
	if (response?.message) {
		window.dispatchEvent(new CustomEvent('canvas-agent:reply', {
			detail: {response, sessionId: envelope.session_id},
		}));
	}
	return response;
}
